import { getCustomerCarts } from "../api/cart";
import {
  flushAllProductChanges,
  hasAnyPendingProductChanges,
} from "./productSyncQueue";
import { selectCustomerCart } from "../reducers/userConfigSlice";

export const selectCustomerWithActiveCart = async ({
  customer,
  dispatch,
  getState,
  initialize = false,
}) => {
  if (!customer?.customerId) throw Error("No se pudo identificar el cliente.");
  if (getState().aplicationConfig.userConfig.order?.orderId)
    throw Error(
      "El cliente de un pedido creado se conserva. Inicia otra venta para cambiarlo.",
    );
  const start = getState().aplicationConfig.userConfig;
  const initializingEmpty =
    initialize &&
    !start.client?.customerId &&
    !start.order?.orderId &&
    !start.cart?.shoppingCartId &&
    !start.cart?.ShoppingCartProducts?.length;
  if (!initializingEmpty && !(await flushAllProductChanges()))
    throw Error(
      "Hay cambios sin guardar. Espera a sincronizar antes de cambiar el cliente.",
    );
  const previous = getState().aplicationConfig.userConfig;
  const response = await getCustomerCarts(
    { customerId: customer.customerId },
    { page: 1, pageSize: 1, state: "ACTIVE" },
  );
  if (response?.error !== false || !Array.isArray(response.data))
    throw Error(
      "No se pudo recuperar la cesta del cliente. La venta actual se conserva. Reintenta.",
    );
  const carts = response.data;
  if (
    carts.some(
      (cart) =>
        cart.state !== "ACTIVE" ||
        cart.customerId !== customer.customerId ||
        !cart.shoppingCartId,
    )
  )
    throw Error(
      "La cesta recibida no corresponde al cliente. La venta actual se conserva.",
    );
  const current = getState().aplicationConfig.userConfig;
  if (
    current.client?.customerId !== previous.client?.customerId ||
    current.cart !== previous.cart ||
    current.order?.orderId ||
    (!initializingEmpty && hasAnyPendingProductChanges())
  )
    throw Error(
      "La venta ha cambiado. Vuelve a seleccionar el cliente cuando se hayan guardado los cambios.",
    );
  const cart = carts[0] || null;
  const savedAddresses = customer.addresses?.shippingAddresses || [];
  const addresses = cart?.address
    ? [
        cart.address,
        ...savedAddresses.filter(
          (value) => value.addressId !== cart.address.addressId,
        ),
      ]
    : savedAddresses;
  dispatch(
    selectCustomerCart({
      client: {
        ...customer,
        addresses: { ...customer.addresses, shippingAddresses: addresses },
      },
      carts,
      cart,
    }),
  );
  return cart;
};
